import React from 'react';

import {
    Facebook,
    Instagram,
    Twitter,
    Youtube,
    MapPin,
    Phone,
    Mail
} from 'lucide-react';
import { Link } from 'react-router-dom';


import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-container container">
                <div className="footer-grid">
                    {/* Brand Column */}
                    <div className="footer-brand">
                        <h3 className="footer-logo">AVNII</h3>
                        <p className="footer-description">
                            From the heart of the Earth comes the finest treasures—gold, silver, and diamonds. Avnii embodies this essence, bringing nature’s brilliance to you. Every piece we craft is not just jewelry, but a reflection of Earth’s timeless beauty and your cherished moments.
                        </p>
                        <div className="social-icons">
                            <a href="https://www.facebook.com/swarnaprakashjewellers/" target="_blank" rel="noopener noreferrer">
                                <Facebook size={18} />
                            </a>
                            <a href="https://www.instagram.com/swarnaprakashjewellers/" target="_blank" rel="noopener noreferrer">
                                <Instagram size={18} />
                            </a>
                            <a href="https://g.co/kgs/jeCmuUq" target="_blank" rel="noopener noreferrer">
                                <MapPin size={18} />
                            </a>
                            <a href="mailto:swarnaprakashjewellers@gmail.com">
                                <Mail size={18} />
                            </a>
                            <a href="tel:+917204429777">
                                <Phone size={18} />
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="footer-column">
                        <h4 className="footer-heading">Quick Links</h4>
                        <ul>
                            {[
                                { label: 'About Us', url: '/aboutus' },
                                { label: 'Schemes', url: '/schemes' },
                                { label: 'New Arrivals', url: '/new-arrivals' },
                                { label: 'Terms and Conditions', url: '/terms-and-conditions' },
                                { label: 'Contact Us', url: '/contactus' }
                            ].map(item => (
                                <li key={item.label}><a href={item.url}>{item.label}</a></li>
                            ))}
                        </ul>

                    </div>

                    {/* Customer Service */}
                    <div className="footer-column">
                        <h4 className="footer-heading">Customer Service</h4>
                        <ul>
                            {[
                                { label: 'My Account', url: '/profile' },
                                { label: 'Shipping & Returns', url: '/shipping-policy' },
                                { label: 'FAQ', url: '/faq' },
                                { label: 'Return Policy', url: '/return-policy' },
                                { label: 'Exchange policy', url: '/exchange-policy' },
                                { label: 'Privacy Policy', url: '/privacy' }
                            ].map(item => (
                                <li key={item.label}><a href={item.url}>{item.label}</a></li>
                            ))}
                        </ul>

                    </div>

                    {/* Contact */}
                    <div className="footer-column">
                        <h4 className="footer-heading">Contact Us</h4>
                        <ul className="footer-contact">
                            <li><MapPin size={18} /><span>Swarna Prakash Jewellers <br />  Joduraste, Karkala, Udupi District - 576117</span></li>
                            <li><Phone size={18} /><span>+91 7204429777</span></li>
                            <li><Mail size={18} /><span>swarnaprakashjewellers@gmail.com</span></li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {currentYear} Avnii. All rights reserved.</p>
                    <div className="footer-links">
                        <a href="#">Terms of Service</a>
                        <a href="/privacy">Privacy Policy</a>
                        <a href="/contactus">Sitemap</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
